<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <vueFooter v-if="$route.meta.showFooter"></vueFooter>
  </div>
</template>

<script>
import vueFooter from "@/components/footer/footer";
export default {
  name: "App",
  components: {
    vueFooter,
  },
  created() {
    if (
      typeof WeixinJSBridge == "object" &&
      typeof WeixinJSBridge.invoke == "function"
    ) {
      handleFontSize();
    } else {
      if (document.addEventListener) {
        document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
      } else if (document.attachEvent) {
        document.attachEvent("WeixinJSBridgeReady", handleFontSize);

        document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
      }
    }

    function handleFontSize() {
      // 设置网页字体为默认大小

      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });

      // 重写设置网页字体大小的事件

      WeixinJSBridge.on("menu:setfont", function () {
        WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      });
    }
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  font-family: "微软雅黑";
  /* font-size: 4vw; */
  box-sizing: border-box;
}
html,
body,
#app {
  height: 100%;
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue